// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as OrderLoaderComponent from "../../../library/map/views/OrderLoaderComponent.bs.js";

function LazyOrderMapWrapperComponent(Props) {
  var order_id = Props.order_id;
  return React.createElement("div", {
              className: "map-iframe-container"
            }, React.createElement(OrderLoaderComponent.make, {
                  order_id: order_id
                }));
}

var make = LazyOrderMapWrapperComponent;

var $$default = LazyOrderMapWrapperComponent;

export {
  make ,
  $$default ,
  $$default as default,
  
}
/* react Not a pure module */
